"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropDownItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));
var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));
var _Radio = require("../radio/Radio");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  avatar: {
    background: 'none',
    color: theme.palette.text.primary,
    height: 24,
    marginRight: 16,
    width: 24
  },
  dpItem: {
    height: 36,
    padding: 16,
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  dpItemDisabled: {
    backgroundColor: theme.palette.action.disabled,
    cursor: 'auto',
    '&:hover': {
      backgroundColor: theme.palette.action.disabled
    }
  },
  dpItemNested: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  checkbox: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(98, 76, 146, .08)'
    }
  },
  periferics: {
    background: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  subMenu: {
    pointerEvents: 'auto'
  }
}));
const DropDownItem = _ref => {
  let {
    text,
    disabled,
    icon,
    radio,
    checkbox,
    cascaded,
    children,
    onClick
  } = _ref;
  const classes = useStyles();
  const [subAnchorEl, setSubAnchorEl] = (0, _react.useState)(null);
  const isSubMenuOpen = Boolean(Boolean(subAnchorEl));
  const [isChecked, setIsChecked] = (0, _react.useState)(false);
  const handleMouseEnter = event => {
    setSubAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setSubAnchorEl(null);
  };
  const handleCheck = () => {
    setIsChecked(!isChecked);
  };
  if (cascaded) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: text,
    className: disabled ? `${classes.dpItem} ${classes.dpItemNested} ${classes.dpItemDisabled}` : `${classes.dpItem} ${classes.dpItemNested}`,
    disableRipple: true,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleClose
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, text), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    style: {
      pointerEvents: 'none'
    },
    anchorEl: subAnchorEl,
    open: isSubMenuOpen,
    getContentAnchorEl: null,
    classes: {
      paper: classes.subMenu
    },
    anchorOrigin: {
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      elevation: 4
    }
  }, children)));
  if (radio || checkbox) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: `${classes.dpItem} ${classes.periferics}`,
    disabled: disabled,
    onClick: onClick
  }, checkbox && !radio && /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      disabled: disabled,
      checked: isChecked,
      onChange: handleCheck,
      name: "checked",
      className: classes.checkbox,
      icon: /*#__PURE__*/_react.default.createElement(_CheckBoxOutlineBlank.default, {
        className: disabled ? null : classes.checkbox
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        className: disabled ? classes.checkboxDisabled : classes.checkbox
      })
    }),
    label: text,
    value: text
  }), radio && !checkbox && /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    value: text,
    control: /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
      disabled: disabled
    }),
    label: text
  }));
  return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: disabled ? `${classes.dpItem} ${classes.dpItemDisabled}` : classes.dpItem,
    disabled: disabled,
    onClick: onClick
  }, icon && /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    icon: icon
  }, icon), !checkbox && !radio || checkbox && radio ? text : null);
};
exports.DropDownItem = DropDownItem;
DropDownItem.propTypes = {
  /**
   * Escolhe o texto do item
   */
  text: _propTypes.default.node,
  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,
  /**
   * Se `true` o campo é um checkbox
   */
  checkbox: _propTypes.default.bool,
  /**
   * Se `true` o campo é um radio button
   */
  radio: _propTypes.default.bool,
  /**
   * Se `true` o campo é cascaded
   */
  cascaded: _propTypes.default.bool,
  /**
   * Preencha para adicionar o source do ícone
   */
  icon: _propTypes.default.node,
  /**
   * o que será colocado no cascade
   */
  children: _propTypes.default.node,
  /**
   * Função que será executada quando o botão for clicado
   */
  onClick: _propTypes.default.func.isRequired
};
DropDownItem.defaultProps = {
  text: 'Item example',
  disabled: false,
  cascaded: false,
  checkbox: false,
  radio: false,
  icon: null,
  children: null
};
var _default = exports.default = DropDownItem;